const INVOICE_ERROR_CODE = 'INVDL';

export const errors = (code) => {
  switch (code) {
    case INVOICE_ERROR_CODE:
      return 'Opps! An error occured downloading your invoice. If the problem persists, contact support';
    default:
      return 'Opps! Something went wrong, if the problem persists, contact support.';
  }
};
